import { put, call } from 'redux-saga/effects';
import { keyLocationAdd, keyLocationDelete, keyLocationList,  eventLocationAdd, eventLocationDelete, eventLocationList,eventLocationCsvImport } from '../../../services/settings/affiliates/locationService';

import * as types from '../../../actions';

export function* keyLocationListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(keyLocationList, payload);
      yield put({ type: types.KEY_LOCATION_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.KEY_LOCATION_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* keyLocationAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(keyLocationAdd, payload);
      yield put({ type: types.KEY_LOCATION_ADD_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.KEY_LOCATION_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}



export function* keyLocationDeleteSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(keyLocationDelete, payload);
      yield put({ type: types.KEY_LOCATION_DELETE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.KEY_LOCATION_DELETE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


export function* eventLocationListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(eventLocationList, payload);
      yield put({ type: types.EVENT_LOCATION_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.EVENT_LOCATION_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventLocationAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(eventLocationAdd, payload);
      yield put({ type: types.EVENT_LOCATION_ADD_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.EVENT_LOCATION_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}



export function* eventLocationDeleteSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(eventLocationDelete, payload);
      yield put({ type: types.EVENT_LOCATION_DELETE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.EVENT_LOCATION_DELETE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventLocationCsvImportSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventLocationCsvImport, payload);
    yield put({ type: types.EVENT_LOCATION_IMPORT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_LOCATION_IMPORT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}